export const USER_REQUEST_LOGIN = "user_request_login";
export const USER_LOGIN_ADMIN = "user_login_admin";
export const USER_CHECK_AUTH = "user_check_auth";
